import React, { useState } from 'react';
import EditableTable from '../inputs/EditableTable';
import AdminMemberTable from './AdminMemberTable';
import { useAuth } from '../../context/auth';
import { useMessage } from '../../context/message';
import DeleteIcon from '@material-ui/icons/Delete';

export default function TeamTable() {
  const [toggle, fetchData] = useState(false)
  const { auth } = useAuth()
  const { setMessage } = useMessage()

  const handleDelete = (rowData) => {
    fetch(`/api/team/${rowData.team_id}`, {
      method: 'DELETE',
      headers: {
        'x-access-token': sessionStorage.getItem('token')
      }
    })
    .then(response => auth(response))
    .then(response => {
      setMessage(response.message)
      if (response.message.type === 'success') {
        fetchData(!toggle)
      }
    })
    .catch(error => {
      setMessage({ type: 'error', text: 'Error! Unable to delete team' })
      console.error('Error:', error)
    })
  }

  const memberTable = (rowData) => {
    return (
      <AdminMemberTable team_id={rowData.team_id} />
    )
  }

  const columns = [
    {
      title: 'Team ID',
      field: 'team_id',
      editable: 'never',
    },
    {
      title: 'Team Name',
      field: 'team_name',
    },
    {
      title: 'Admin',
      field: 'username',
      editable: 'never',
    },
    {
      title: 'Admin ID',
      field: 'admin_id',
    },
    {
      title: 'Max User Count',
      field: 'max_users',
    }
  ];

  return (
    <EditableTable
      title='Teams'
      table='team'
      toggle = {toggle}
      fetchData = {fetchData}
      columns={columns}
      ownership='all'
      detailPanel = {memberTable}
      actions={[
        {
          icon: () => <DeleteIcon />,
          tooltip: 'Delete Team',
          onClick: (event, rowData) => handleDelete(rowData)
        }
      ]}
    />
  );
}
